import { render, staticRenderFns } from "./core-values.vue?vue&type=template&id=5087af98&scoped=true&"
import script from "./core-values.vue?vue&type=script&lang=js&"
export * from "./core-values.vue?vue&type=script&lang=js&"
import style0 from "./core-values.vue?vue&type=style&index=0&id=5087af98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5087af98",
  null
  
)

export default component.exports